export const TAG = 'CkaActionDetails';
